import { connect } from "react-redux";
import CalculatedPayment from "Shared/CalculatedPayment";
import { getPayments, isVehicleLoading, isVehicleUpdating } from "src/store/selectors/vehicles";
import { ApplicationStore } from "Types/state";
import { isCalculateTaxesCustomerRequest } from "src/store/selectors/financeSettings";
import { openSubModal } from "src/store/actions/onlineShopper/subModal";
import { getAccountPhoneNumber } from "src/store/selectors/account";

interface CalculatedPaymentProps {
    vin?: string;
}
export function mapStateToProps(state: ApplicationStore, props?: CalculatedPaymentProps) {
    const { account, onlineShopper } = state;
    const vin = props?.vin || onlineShopper.toggledVin!;
    return {
        vin,
        account,
        isPaymentsLoading: isVehicleLoading(state, vin) || isVehicleUpdating(state, vin),
        payments: getPayments(state, vin),
        isTaxesCustomerRequested: isCalculateTaxesCustomerRequest(state),
        phoneNumber: getAccountPhoneNumber(state),
    };
}

const mapDispatchToProps = (dispatch: any) => ({
    openPaymentPlanReviewModal: (vin: string) => dispatch(openSubModal({ modalType: "paymentPlanReviewModal", vin })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalculatedPayment);
